<template>
    <TemplateBase
        v-if="entry"
        :key="entry.id"
        class="template template--content"
    >
        <template #hero>
            <BaseHero
                :title="hero?.title ?? entry.title"
                :description="hero.subtitle"
                :cta="hero.cta"
                :footer-text="hero.footer"
                masked-background
            />
        </template>

        <template #default>
            <ContentBlocks v-if="entry?.contentBlocks" :content-blocks="entry.contentBlocks" />

            <NewsletterSignup v-if="entry.newsletterSignupVisible" />
            <CtaCardsBlock v-if="entry.ctaCardsVisible" />
        </template>
    </TemplateBase>
</template>

<script setup>
const props = defineProps({
    entry: {
        type: Object,
        default: () => {},
        required: true
    }
});

const { entry } = toRefs(props);

const hero = computed(() => {
    if (entry.value?.defaultHero?.[0]) {
        return entry.value.defaultHero[0];
    } else if (entry.value?.projectHero?.[0]) {
        return entry.value.projectHero[0];
    }
});
</script>
